import { ArrowRightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useCallback, useContext } from 'react';

import './VendorLeadStepStart.scss';

import LogoText from 'src/assets/logo-text.svg?react';
import StartVideoPoster from 'src/assets/start-page-video-poster.jpg';
import StartVideo from 'src/assets/start-page-video.mp4';
import { VendorLeadStepper } from 'src/components/vendors/steps/VendorLeadStepper';
import { VendorsContext } from 'src/pages/VendorsPage/VendorsPage.context';
import { VendorPageStep } from 'src/pages/VendorsPage/VendorsPage.context.types';

export function VendorLeadStepStart() {
  const { vendorLeadProduct, setVendorStep } = useContext(VendorsContext);

  const isContinue = !!vendorLeadProduct?.submittedFieldGroups.length;

  const handleStartClick = useCallback(() => setVendorStep(VendorPageStep.Pictures), [setVendorStep]);

  return (
    <div className="vendor-lead-step-start__layout">
      <div className="vendor-lead-step-start__layout__left" />
      <div className="vendor-lead-step-start__layout__center">
        <div className="vendor-lead-step-start__layout__center__header">
          <div className="vendor-lead-step-start__layout__center__header__logo">
            <div className="vendor-lead-step-start__layout__center__header__logo-icon" />
            <LogoText className="vendor-lead-step-start__layout__center__header__logo-text" />
          </div>
        </div>

        <div className="vendor-lead-step-start__layout__center__content">
          <div className="vendor-lead-step-start__layout__center__title">
            {isContinue ? 'Let’s continue!' : 'Let’s get started!'}
          </div>
          <div className="vendor-lead-step-start__layout__center__text">
            Application process contains few steps which take around 5 minutes, Pictures are most required and most
            important
          </div>
          <div className="vendor-lead-step-start__layout__center__stepper">
            <VendorLeadStepper isStartPage={true} />
          </div>
          <div className="vendor-lead-step-start__layout__center__footer">
            <Button
              className="vendor-lead-step-start__layout__center__footer__start-button"
              type="primary"
              icon={<ArrowRightOutlined />}
              onClick={handleStartClick}
            >
              {isContinue ? 'Continue' : 'Start application'}
            </Button>
          </div>
        </div>
      </div>
      <div className="vendor-lead-step-start__layout__right">
        <div className="vendor-lead-step-start__video-container">
          <video
            controls={false}
            loop={true}
            autoPlay={true}
            playsInline={true}
            muted={true}
            poster={StartVideoPoster}
            disablePictureInPicture={true}
          >
            <source src={StartVideo} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
}
